export enum TextColorEnum {
  BLACK = 'black',
  WHITE = 'white',
  BLUE = 'blue',
  GREY = 'grey',
}
